import { addIcon } from '@iconify/vue'
import arrowLeft from '@iconify-icons/solar/arrow-left-linear'
import arrowRight from '@iconify-icons/solar/arrow-right-linear'
import arrowRightUp from '@iconify-icons/solar/arrow-right-up-linear'
import calendarMark from '@iconify-icons/solar/calendar-mark-linear'
import chart from '@iconify-icons/solar/chart-2-linear'
import checkCircle from '@iconify-icons/solar/check-circle-linear'
import clipboardCheck from '@iconify-icons/solar/clipboard-check-linear'
import compass from '@iconify-icons/solar/compass-big-linear'
import dialog from '@iconify-icons/solar/dialog-2-linear'
import documentText from '@iconify-icons/solar/document-text-linear'
import graphUp from '@iconify-icons/solar/graph-up-linear'
import home from '@iconify-icons/solar/home-2-linear'
import lightbulb from '@iconify-icons/solar/lightbulb-bolt-linear'
import magnifer from '@iconify-icons/solar/magnifer-linear'
import microphone from '@iconify-icons/solar/microphone-3-linear'
import moon from '@iconify-icons/solar/moon-stars-linear'
import notebook from '@iconify-icons/solar/notebook-bookmark-linear'
import playCircle from '@iconify-icons/solar/play-circle-linear'
import questionCircle from '@iconify-icons/solar/question-circle-linear'
import radar from '@iconify-icons/solar/radar-2-linear'
import refreshCircle from '@iconify-icons/solar/refresh-circle-linear'
import settings from '@iconify-icons/solar/settings-linear'
import shieldWarning from '@iconify-icons/solar/shield-warning-linear'
import academicCap from '@iconify-icons/solar/square-academic-cap-2-linear'
import sun from '@iconify-icons/solar/sun-2-linear'
import user from '@iconify-icons/solar/user-rounded-linear'

const icons = {
  'arrow-left-linear': arrowLeft,
  'arrow-right-linear': arrowRight,
  'arrow-right-up-linear': arrowRightUp,
  'calendar-mark-linear': calendarMark,
  'chart-2-linear': chart,
  'check-circle-linear': checkCircle,
  'clipboard-check-linear': clipboardCheck,
  'compass-big-linear': compass,
  'dialog-2-linear': dialog,
  'document-text-linear': documentText,
  'graph-up-linear': graphUp,
  'home-2-linear': home,
  'lightbulb-bolt-linear': lightbulb,
  'magnifer-linear': magnifer,
  'microphone-3-linear': microphone,
  'moon-stars-linear': moon,
  'notebook-bookmark-linear': notebook,
  'play-circle-linear': playCircle,
  'question-circle-linear': questionCircle,
  'radar-2-linear': radar,
  'refresh-circle-linear': refreshCircle,
  'settings-linear': settings,
  'shield-warning-linear': shieldWarning,
  'square-academic-cap-2-linear': academicCap,
  'sun-2-linear': sun,
  'user-rounded-linear': user,
}

Object.entries(icons).forEach(([name, data]) => addIcon(`solar:${name}`, data))
